import { mediaMixin, token } from '@zillow/constellation';
import styled, { css } from 'styled-components';

type ColumnProps = {
  $shouldHideOnMobile: boolean;
};

export const StyledSecondaryColumn = styled.section<ColumnProps>`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  width: 100%;
  position: relative;

  ${mediaMixin(
    'xxl',
    css`
      && {
        min-width: 0%;
        max-width: 50%;
        border-right: 1px solid ${token('colors.gray300')};
      }
    `,
  )}

  ${(props) =>
    props.$shouldHideOnMobile &&
    mediaMixin(
      'xl_lte',
      css`
        && {
          display: none;
        }
      `,
    )}
`;
